export const getParamFromQueryString = (
  hrefSearch: string | URLSearchParams | string[][] | Record<string, string> | undefined,
  name: string
): string | null => {
  const search = new URLSearchParams(hrefSearch).get(name);

  return search || null;
};
